import React from "react";
import { useTranslation } from "react-i18next";
import { LabelProps } from "../types";

export const Label: React.FC<LabelProps> = ({ label, required }) => {
  const { t } = useTranslation();
  return (
    <label className="input-label">
      {t(label)}
      {required && <i className="input-required">*</i>}
    </label>
  );
};
